import moment from 'moment';

export const isDateToday = (date: Date) =>
  moment(date).isSame(Date.now(), 'day');

export const idToDate = (id: string): Date =>
  new Date(1000 * parseInt(id.substr(0, 8), 16));

export const formatHumanDate = (date: Date) => {
  const momentDate = moment(new Date(date));
  const now = moment();

  const isAmbiguousMonth = Math.abs(now.diff(momentDate, 'months')) > 9;
  const shouldHideYear = momentDate.isSame(now, 'year') && !isAmbiguousMonth;

  return momentDate.format(shouldHideYear ? 'llll' : 'll');
};
